// @ts-nocheck

import * as R from 'ramda';
import { LOADING_STATUS } from '../support/constants';
import { reducerWrapper } from '../support/utils';

import { THIRD_PARTY_GLOBAL_GET, THIRD_PARTY_GLOBAL_PATCH } from '../actions/ThirdPartyGlobalSettingsActions';

var INIT_STATE = {
  loading: false,
  loadingStatus: LOADING_STATUS.INIT,
  error: null,
  data: {},
};

function Handler(state, action) {
  switch (action.type) {
    case THIRD_PARTY_GLOBAL_GET.response:
      return R.merge(state, {
        loading: false,
        loadingStatus: LOADING_STATUS.LOADED,
        error: null,
        data: action.data,
      });

    case THIRD_PARTY_GLOBAL_PATCH.response:
      return R.merge(state, {
        loading: false,
        loadingStatus: LOADING_STATUS.LOADED,
        error: null,
        data: action.data,
      });

    default:
      return state;
  }
}

const ThirdPartyGlobalSettings = reducerWrapper(INIT_STATE, Handler, {
  request: [THIRD_PARTY_GLOBAL_GET, THIRD_PARTY_GLOBAL_PATCH],
  error: [THIRD_PARTY_GLOBAL_GET, THIRD_PARTY_GLOBAL_PATCH],
  resetOn: ['APP_CHANGE'],
});

export default ThirdPartyGlobalSettings;
